import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import {
  Alert,
  Box as DarkBox,
  Modal as DarkModal,
  Text as DarkText,
} from '@hivewatch/dark'

interface IProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
  incidentName: string
  displayId: string
  isLoading: boolean
}

export const ReleaseIncidentModal = ({
  isOpen,
  onClose,
  onSubmit,
  incidentName,
  displayId,
  isLoading,
}: IProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()

  return (
    <DarkModal
      bodyStyleOverrides={{ pb: '8px' }}
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveDestructive
      isSaveLoading={isLoading}
      onClose={onClose}
      onSave={onSubmit}
      saveButtonLabel={t('incidents:incident_drawer_release_title')}
      showCancelButton
      size='compact'
      title={t('incidents:incident_drawer_release_title')}
      zIndex={1500}
    >
      <DarkText
        color={
          colorScheme === 'light' ? 'light.text.secondary' : 'text.secondary'
        }
        textStyle='caption'
      >
        {t('incidents:incident_drawer_release_incident_name_label')}
      </DarkText>
      <DarkText
        color={colorScheme === 'light' ? 'light.text.primary' : 'text.primary'}
        mt='4px'
        textStyle='heading'
      >
        {`${displayId} ${incidentName}`}
      </DarkText>
      <DarkBox mt='16px'>
        <Alert
          colorScheme={colorScheme}
          description={t('incidents:incident_drawer_release_warning')}
          title={t('common:warning_title')}
          variant='warning'
        />
      </DarkBox>
    </DarkModal>
  )
}
